
export default {
    name: "JobCardChip",
}
